import { useContext } from 'react'
import { useStore } from 'zustand'

import { AppStore, StoreContext, StoreProps } from './store-provider'

export const useAppStore = (selector?: any) => {
  const store = useContext(StoreContext)

  if (!store) {
    throw new Error('useStore must be used within a StoreProvider')
  }

  return useStore<AppStore, StoreProps>(store, selector)
}
